module.exports = __webpack_public_path__ + "static/media/maestro_logo_tagline_allwhite.3f0c0b52.svg";